import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import AddTaskComponent from '../Home/Components/AddTaskComponent';
import TaskAssignedRow from './TaskAssignedRow';
import TaskAssignedElement from './TaskAssignedElement';
import api from '../api/api';

const TaskAssigned = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [data, setData] = useState({
    "انجام نشده": [],
    "در حال انجام": [],
    "انجام شده": []
  });
  const [loading, setLoading] = useState(true);

  const columnStyles = {
    "انجام نشده": { border: "border-slate-400", text: "text-slate-800", badge: "bg-slate-200 text-slate-700" },
    "در حال انجام": { border: "border-indigo-500", text: "text-indigo-800", badge: "bg-indigo-100 text-indigo-700" },
    "انجام شده": { border: "border-green-500", text: "text-green-800", badge: "bg-green-100 text-green-700" }
  };

  const fetchTasks = async () => {
    try {
      const res = await api.get('/tasks/?role=created');
      const tasks = res.data;
      const grouped = {
        "انجام نشده": tasks.filter(t => t.status === 'انجام نشده'),
        "در حال انجام": tasks.filter(t => t.status === 'در حال انجام'),
        "انجام شده": tasks.filter(t => t.status === 'انجام شده')
      };
      setData(grouped);
    } catch (error) {
      console.error('Error fetching tasks:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(fetchTasks, 10000);
    return () => clearInterval(intervalId);
  }, []);

  const onDragEnd = async (result) => {
    const { source, destination } = result;
    if (!destination) return;
    const newData = { ...data };
    const [movedItem] = newData[source.droppableId].splice(source.index, 1);
    newData[destination.droppableId].splice(destination.index, 0, movedItem);
    setData(newData);
    try {
      await api.patch(`/tasks/${movedItem.id}/`, { status: destination.droppableId });
    } catch (error) {
      console.error('Error updating task status:', error);
      fetchTasks();
    }
  };

  if (loading) return <div className="p-8 text-center">در حال بارگذاری...</div>;

  return (
    <div className="p-6 bg-slate-50 min-h-screen" dir="rtl">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-xl font-bold text-slate-800">کارهای محوله</h1>
          {selectedStatus && (
            <button onClick={() => setSelectedStatus(null)} className="text-xs text-indigo-600 font-bold mt-2 hover:underline">← بازگشت به نمای ستونی</button>
          )}
        </div>
        <button onClick={() => setIsModalOpen(true)} className="bg-rose-600 text-white px-6 py-2 rounded-xl text-sm font-bold shadow-lg hover:bg-rose-700 transition-all">+ محول کردن کار</button>
      </div>

      {selectedStatus ? (
        <table className="w-full bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-100">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
            <tr>
              <th className="p-4 text-right">عنوان کار</th>
              <th className="p-4 text-right">توضیحات</th>
              <th className="p-4 text-right">مهلت</th>
              <th className="p-4 text-right">وضعیت</th>
              <th className="p-4 text-right">مسئول</th>
            </tr>
          </thead>
          <tbody>
            {data[selectedStatus].length > 0 ? (
              data[selectedStatus].map((task) => <TaskAssignedElement key={task.id} {...task} status={selectedStatus} />)
            ) : (
              <tr><td colSpan="5" className="p-8 text-center text-slate-400 text-sm">کاری برای نمایش وجود ندارد</td></tr>
            )}
          </tbody>
        </table>
      ) : (
        <DragDropContext onDragEnd={onDragEnd}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {Object.keys(data).map((columnName) => (
              <Droppable key={columnName} droppableId={columnName}>
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef} className="flex flex-col min-h-[500px]">
                    <div 
                      onClick={() => setSelectedStatus(columnName)}
                      className={`flex justify-between items-center mb-4 pb-2 border-b-2 cursor-pointer hover:opacity-80 transition-opacity ${columnStyles[columnName].border}`}
                    >
                      <h2 className={`font-bold text-sm ${columnStyles[columnName].text}`}>{columnName}</h2>
                      <span className={`w-8 h-8 flex items-center justify-center rounded-full text-xs font-black shadow-sm ${columnStyles[columnName].badge}`}>
                        {data[columnName].length}
                      </span>
                    </div>
                    {data[columnName].map((item, index) => (
                      <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                        {(provided) => (
                          <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className="mb-3">
                            <TaskAssignedRow {...item} />
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            ))}
          </div>
        </DragDropContext>
      )}

      {isModalOpen && <AddTaskComponent onClose={() => { setIsModalOpen(false); fetchTasks(); }} forcedAssignee="دیگران" />}
    </div>
  );
};

export default TaskAssigned;